import { getDeliveryCenter } from "../api/DeliveryCenter/deliveryCenter";
import store from "../store/store";
import {
  setDeliveryCenter,
  setShowDeliveryCenterSetupModal,
} from "../store/actions/deliveryCenterSlice";
import { setCenter } from "../store/actions/mapSlice";

export const checkDeliveryCenterRegister = async () => {
  try {
    const { data } = await getDeliveryCenter();
    console.log("getDeliveryCenter", data.length);

    if (data.length === 0) {
      store.dispatch(setShowDeliveryCenterSetupModal(true));
      return false;
    }

    store.dispatch(setShowDeliveryCenterSetupModal(false));

    const deliveryCenter = data[0];
    const { lat, lng } = deliveryCenter;

    store.dispatch(setDeliveryCenter(deliveryCenter));
    store.dispatch(setCenter({ lat: parseFloat(lat), lng: parseFloat(lng) }));

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
